class Footer {
  constructor(parent) {
    if (parent.length === 0) {
      return
    }
    this.parent = parent;
    this.init();
  }

  clickEvent = () => {
    document.addEventListener("click",(e) => {
      let that = e.target;
      if (that.closest('.contact-us-wrapper') || that.classList.contains("contact-us-wrapper")) {
        that?.closest('.contact-us-wrapper')?.querySelector("h4")?.classList?.toggle("active");
        that?.closest('.contact-us-wrapper')?.classList?.toggle('active-tab-data');
      }
    })
    let popularSearh = document.querySelector('.popular-links-bottom .link-label');
    if(popularSearh){
      let popularSearhWrap = document.querySelector('.popular-links-bottom');
      let popularSearhWrapMenu = document.querySelector('.popular-links-bottom .menu');

      popularSearh.addEventListener('click',(e)=>{
        if(popularSearhWrap){
          popularSearhWrap.classList.toggle('active')
          if(popularSearhWrapMenu){
            popularSearhWrapMenu?.scrollIntoView({
              behavior: 'smooth',
              block: 'start',    
              inline: 'nearest'  
            });
          }
        }
      })
    }
  }

  init = () => {
    this.clickEvent();
  }  
}

document.addEventListener('DOMContentLoaded', () => {
  new Footer(document.querySelector('.footer-container'));
}, false);